import { render, staticRenderFns } from "./KS-JP.vue?vue&type=template&id=6f5c359e&scoped=true&"
import script from "./KS-JP.vue?vue&type=script&lang=js&"
export * from "./KS-JP.vue?vue&type=script&lang=js&"
import style0 from "./KS-JP.vue?vue&type=style&index=0&id=6f5c359e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c359e",
  null
  
)

export default component.exports